import { render, staticRenderFns } from "./PainelGerente.vue?vue&type=template&id=66d60c3a&"
import script from "./PainelGerente.vue?vue&type=script&lang=js&"
export * from "./PainelGerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports